// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"OutsourcedVendorsManagement--next-sr-only--2Dnxvi3","pageContainer":"OutsourcedVendorsManagement--pageContainer--3e_Dzss"};